import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Container, TextField } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/Custom/CustomButton";
import useFormValidation from "../../components/Custom/FormValidation";
import { createCropValidationSchema } from "../../components/Custom/ValidationSchema";
import { createProgramInputTask } from "../../api/programs";

const validationSchema = createCropValidationSchema();

export default function CreateProgramInputTask() {
  const navigate = useNavigate();
  const { programInputId } = useParams();

  const [formData, setFormData] = useState({});
  const { t } = useTranslation();
  const { errors, validate } = useFormValidation(formData, validationSchema);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      program_input: programInputId,
    };
    await createProgramInputTask(payload);
    navigate(-1);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add Task")}</CustomTitle>

            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Name")}
              name="name"
              value={formData.name || ""}
              error={!!errors.name}
              helperText={errors.name}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Application Type")}
              name="application_type"
              value={formData.application_type || ""}
              error={!!errors.application_type}
              helperText={errors.application_type}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Activity")}
              name="activity"
              value={formData.activity || ""}
              error={!!errors.activity}
              helperText={errors.activity}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="number"
              label={t("Quantity")}
              name="quantity"
              value={formData.quantity || ""}
              error={!!errors.quantity}
              helperText={errors.quantity}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Unit")}
              name="unit"
              value={formData.unit || ""}
              error={!!errors.unit}
              helperText={errors.unit}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              label={t("Start Date")}
              name="start_date"
              value={formData.start_date || ""}
              error={!!errors.start_date}
              helperText={errors.start_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="date"
              label={t("Due Date")}
              name="due_date"
              value={formData.due_date || ""}
              error={!!errors.due_date}
              helperText={errors.due_date}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="text"
              label={t("Comments")}
              name="comments"
              value={formData.comments || ""}
              error={!!errors.comments}
              helperText={errors.comments}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            <CustomButton onClick={handleSubmit}>{t("Save")}</CustomButton>
          </Grid>
        </div>
      </Container>
    </>
  );
}
